import { NiceModalHandler } from '@ebay/nice-modal-react';
import { Button } from '@mui/material';
import classNames from 'classnames';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { implog } from '@/api/implog';
import { modalStore } from '@/stores/modal';

import styles from './styles.module.less';

const VipWithdrawInfoModal = (modal: NiceModalHandler) => {
  const navigate = useNavigate();

  const location = useLocation();
  useEffect(() => {
    implog('modal_withdraw_vip_info_show');
  }, []);
  return (
    <div className={styles.main}>
      <div className={styles.content}>
        <div className={styles['content-icon']}>★ </div>
        <div className={styles['content-label']}>Recharge required for withdrawal. </div>
      </div>
      <div className={styles.content}>
        <div className={styles['content-icon']}>★ </div>
        <div className={styles['content-label']}>The minimum withdrawal amount for games is $40.</div>
      </div>
      <Button
        className={classNames(styles.btn, 'global_button_succes')}
        sx={{
          width: '2.8rem',
          fontSize: '0.32rem',
          height: '0.8rem',
          borderRadius: '0.4rem'
        }}
        variant="text"
        onClick={async () => {
          implog('modal_withdraw_vip_info_click');
          if (location?.pathname === '/recharge') {
            modalStore.openFirstRecharge();
          } else {
            navigate('/recharge');
          }
          modal?.hide();
        }}
      >
        Deposit
      </Button>
    </div>
  );
};

export default VipWithdrawInfoModal;
